namespace Matrix.Data {
    export class ListItemColumns {
        static columnsKey = 'Data.ListItem';
    }
}
